"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceCotopaxi = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const andes_react_1 = require("@yonderland/andes-react");
const sizeToVariantMapping = new Map([
    [cotopaxi_1.PriceSize.SMALL, 'bodyXS'],
    [cotopaxi_1.PriceSize.MEDIUM, 'bodyXS'],
    [cotopaxi_1.PriceSize.LARGE, 'bodyM'],
    [cotopaxi_1.PriceSize.XLARGE, 'bodyM'],
]);
const ProductPriceCotopaxi = (props) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ProductPrice, Object.assign({}, props)), props.enablePriceReference && ((0, jsx_runtime_1.jsx)(andes_react_1.PriceReference, Object.assign({ variant: props.size ? sizeToVariantMapping.get(props.size) : 'bodyM' }, props)))] }));
exports.ProductPriceCotopaxi = ProductPriceCotopaxi;
